<template>
    <div>
        내의뢰 진행사항
    </div>
</template>

<script>
export default {
    name: "DetectionListMyRequestLayout",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {}
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        moveDetail(url) {
            this.$router.push(`${url}`);
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>